import { UpdateTemplateCategoryV2, UpdateTemplateCategoryV2Variables } from './__generated__/UpdateTemplateCategoryV2'
import { DeleteTemplateMessageV2, DeleteTemplateMessageV2Variables } from './__generated__/DeleteTemplateMessageV2'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const CATEGORY_MUTATION = gql`
  mutation UpdateTemplateCategoryV2($input: UpdateTemplateCategoryInputV2!) {
    updateColorTemplate: updateTemplateCategoryV2(input: $input) {
      __typename
      ... on TemplateCategoryV2 {
        id
        title
      }
      ... on TemplateCategoryErrorV2 {
        type
        error
      }
    }
  }
`

const DELETE_MESSAGE_MUTATION = gql`
  mutation DeleteTemplateMessageV2($input: DeleteTemplateMessageInputV2!) {
    deleteTemplateMessageV2(input: $input) {
      __typename
      ... on TemplateMessageV2 {
        id
      }
      ... on TemplateMessageErrorV2 {
        type
        error
      }
    }
  }
`

export const useUpdateColorTemplate = () => {
  return useMutation<UpdateTemplateCategoryV2, UpdateTemplateCategoryV2Variables>(CATEGORY_MUTATION)
}

export const useDeleteTemplateMessage = () => {
  return useMutation<DeleteTemplateMessageV2, DeleteTemplateMessageV2Variables>(DELETE_MESSAGE_MUTATION)
}
